import React from "react";
import { Box, Typography, Stack } from "@mui/material";

const IngredientPriceHistoryTimeline = ({
  priceHistory = [],
  unit,
  currentPrice,
  currentUnitAmount,
}) => {
  const sorted = [...priceHistory].sort(
    (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
  );

  return (
    <Box sx={{ my: 3 }}>
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Price History
      </Typography>

      <Box sx={{ position: "relative", ml: 2 }}>
        {/* Vertical line */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: -3,
            width: "2px",
            backgroundColor: "#ccc",
          }}
        />

        <Stack spacing={3} sx={{ pl: 1 }}>
          {/* Oldest → Newest */}
          {sorted.map((entry, index) => {
            console.log(entry);
            const date =
              entry.date && !isNaN(new Date(entry.date))
                ? new Date(entry.date).toLocaleString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })
                : "No Date";

            return (
              <Box key={index} sx={{ position: "relative", pl: 1 }}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "0.5em",
                    left: "-16px",
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    backgroundColor: "#fff",
                    border: "3px solid #FD7762",
                    boxSizing: "border-box",
                  }}
                />
                <Typography variant="body2">
                  <strong>${entry.costPerUnit.toFixed(2)}</strong> per{" "}
                  <em>{`${entry.unitAmount} ${unit}`}</em>
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {date}
                </Typography>
              </Box>
            );
          })}

          {/* ✅ Current price always on top */}
          <Box sx={{ position: "relative", pl: 1 }}>
            <Box
              sx={{
                position: "absolute",
                top: "0.5em",
                left: "-16px",
                width: 12,
                height: 12,
                borderRadius: "50%",
                backgroundColor: "#FD7762",
                border: "3px solid #FD7762",
                boxSizing: "border-box",
              }}
            />
            <Typography variant="body2">
              <strong>${currentPrice.toFixed(2)}</strong> per{" "}
              <em>{`${currentUnitAmount} ${unit}`}</em>{" "}
              <span style={{ color: "#4CAF50", fontWeight: 600 }}>
                (Current Price)
              </span>
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Active Now
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default IngredientPriceHistoryTimeline;
